import { Divider } from '../layout/divider.js'

export const DndDivider = () => (
  <Divider style={{ borderWidth: 2, borderColor: 'var(--tuna-palette-primary-main)' }} />
)

export default DndDivider
